/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-console, no-underscore-dangle */
/* global Event */

import React from 'react';
import PropTypes from 'prop-types';

import './KeyboardExtraBar.styles.scss';
import {
  isMobileApplication,
  isKeyboardOpen,
} from '../../utilities/MobileUtil';
import AppUtils from '../../utilities/AppUtils';
import KeyboardExtraBarAmount from './KeyboardExtraBarAmount';
import KeyboardExtraBarValue from './KeyboardExtraBarValue';

const EXTRA_BAR_HEIGHT = 50;
class KeyboardExtraBar extends React.Component {
  constructor(props) {
    super(props);
    this.initClientKeyboard = this.initClientKeyboard.bind(this);
    this.toggleKeyboard = this.toggleKeyboard.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onSubmitPress = this.onSubmitPress.bind(this);
    this.state = {
      extraBar: false,
      keyboardHeight: 0,
    };
    this.input = null;
  }

  componentDidMount() {
    if (AppUtils.isMobileDevice() && !isMobileApplication()) {
      window.addEventListener('resize', this.initClientKeyboard);
    }
    if (isMobileApplication()) {
      window.addEventListener('native.keyboardshow', this.toggleKeyboard);
      window.addEventListener('native.keyboardhide', this.toggleKeyboard);
    }
  }

  componentWillUnmount() {
    if (AppUtils.isMobileDevice() && !isMobileApplication()) {
      window.removeEventListener('resize', this.initClientKeyboard);
    }
    if (isMobileApplication()) {
      window.removeEventListener('native.keyboardshow', this.toggleKeyboard);
      window.removeEventListener('native.keyboardhide', this.toggleKeyboard);
    }
  }
  onKeyPress(label) {
    const { value: lastValue, selectionStart, selectionEnd } = this.input;
    const updatedValue = `${lastValue.slice(0, selectionStart)}${label}${lastValue.slice(selectionEnd)}`;

    this.input.value = updatedValue;
    if (Event) {
      const event = new Event('change', { bubbles: true });
      event.simulated = true;
      // HACK: see https://github.com/facebook/react/issues/11488#issuecomment-347775628
      const tracker = this.input._valueTracker;
      if (tracker) {
        tracker.setValue(lastValue);
      }
      this.input.dispatchEvent(event);
    } else this.input.fireEvent('onchange');
    this.input.focus();

    const updatedSelectionIndex = selectionStart + label.length;
    this.input.setSelectionRange(updatedSelectionIndex, updatedSelectionIndex);
  }

  onSubmitPress() {
    this.input.blur();
  }

  setupInput(active) {
    this.input = active;
  }

  toggleKeyboard(e) {
    const contentArea = document.querySelector(this.props.contentAreaCssSelector);

    if (!contentArea) { return; }

    if (e && e.keyboardHeight) {
      window.keyboardHeight = window.innerHeight - e.keyboardHeight;
      contentArea.style.paddingBottom = `${EXTRA_BAR_HEIGHT}px`;
      this.setState({ extraBar: true, keyboardHeight: e.keyboardHeight });
    } else {
      window.keyboardHeight = window.innerHeight;
      contentArea.style.paddingBottom = '0';
      this.setState({ extraBar: false, keyboardHeight: 0 });
    }
  }

  input;

  initClientKeyboard() {
    if (isKeyboardOpen()) {
      this.setState({ extraBar: true });
    } else {
      this.setState({ extraBar: false });
    }
  }

  /* Rendering */
  renderExtrabar(type) {
    if (/amount_value_/.test(type)) {
      return (
        <KeyboardExtraBarValue
          onKeyPress={this.onKeyPress}
          onSubmitPress={this.onSubmitPress}
        />
      );
    }
    switch (type) {
      case 'amount_value':
      case 'frequency_times_value':
        return (
          <KeyboardExtraBarAmount
            onKeyPress={this.onKeyPress}
            onSubmitPress={this.onSubmitPress}
          />
        );
      case 'lab_amount_value':
        return (
          <KeyboardExtraBarValue
            onKeyPress={this.onKeyPress}
            onSubmitPress={this.onSubmitPress}
          />
        );
      default:
        return null;
    }
  }

  render() {
    const active = document.activeElement;
    if (active && active.type === 'tel') this.setupInput(active);
    return !AppUtils.isIosDevice() && this.state.extraBar ? (
      <div
        className={'cmp-keyboard-extra-bar'}
        style={{ bottom: 0 }}
      >
        {this.renderExtrabar(active.name)}
      </div>
    ) : null;
  }
}

KeyboardExtraBar.propTypes = {
  contentAreaCssSelector: PropTypes.string.isRequired,
};

export default KeyboardExtraBar;
